import { getCdnURl } from '@/utils/getCdnUrl'

import { Mode } from '@/types/environment'

/**
 * Формируем ссылку на cdn изображений проекта
 * @param src - путь к файлу
 */
export const getImage = (src: string) => {
  const { MODE, PIPELINE_ID } = useRuntimeConfig().public

  /* Eсли это уже ссылка на картинку */
  if (src.includes('http')) return { url: src }

  /* В Development или если не передан PIPELINE_ID - берем статику из dist */
  if (MODE === Mode.DEVELOPMENT || !PIPELINE_ID) {
    return { url: src }
  }

  let baseURL = getCdnURl(MODE, PIPELINE_ID)

  /* Проверка, вдруг url не будет - берем статику из dist */
  if (!baseURL) return { url: src }

  baseURL = `${baseURL}images${src}`

  return { url: baseURL }
}
